import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from "react-router-dom";
import { keycloak,KeycloakService } from './service/KeyCloakService';
import { Dropdown } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';
import { ButtonMenu } from './components/common/ButtonMenu';

export const AppTopbar = (props) => {
    const history = useNavigate();
    const langs=[{label:'English',value:'en-US'},{label:'Türkçe',value:'tr-TR'}];
    const { t, i18n } = useTranslation();
    const [lang,setLang]=useState(i18n.language);

    const setLanguage=(val)=>{
        i18n.changeLanguage(val); 
        setLang(val);       
    }
    const userMenu=()=>{
        return [
            {label:'Quit',icon:'pi pi-power-off',command:()=> keycloak.logout()}
        ];
    }
    return (
        <div className="layout-topbar shadow-2 clearfix">
            <button type="button" className="p-link layout-menu-button" onClick={props.onToggleMenu}>
                <span className="pi pi-bars" />
            </button>
            <div className="layout-topbar-icons flex flex-row align-items-baseline">
                <ButtonMenu className="layout-topbar-user-menu" items={userMenu()} outlined label={keycloak.tokenParsed?.name}></ButtonMenu>
                <Dropdown value={lang} options={langs} onChange={(e) => setLanguage(e.value)} className="ml-4 layout-topbar-lang"/> 
            </div>
        </div>

    );
}
export default AppTopbar;